class CartNotification extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.notification = document.querySelector('[data-cart-notification]');
    this.validContent = this.querySelector('[data-cart-notification-valid]');
    this.invalidContent = this.querySelector('[data-cart-notification-invalid]');

    this.trigger;

    this.debouncedShow = debounce(options => this.fetchAndShow(options), 300);

    // refocus the trigger on close
    this.notification.addEventListener('close', () => {
      if (this.trigger) this.trigger.focus();
    });
  }

  /**
   * Fetches the notification sections and shows the added product.
   * Called directly by product-form-component after a successful add to cart;
   * the icon bubble is not fetched here because the cart section renderer updates it.
   */
  show({ addedVariantId, trigger }) {
    this.debouncedShow({ addedVariantId,
      trigger });
  }

  open(hasError = false) {
    if (hasError) {
      this.validContent.classList.add('hidden');
      this.invalidContent.classList.remove('hidden');
    }
    else {
      this.invalidContent.classList.add('hidden');
      this.validContent.classList.remove('hidden');
    }

    this.notification.showModal();
  }

  fetchAndShow({ addedVariantId, trigger }) {
    this.trigger = trigger || null;

    fetch(`${window.location.pathname}?sections=theme-cart-notification-product,theme-cart-notification-button`)
      .then(response => response.json())
      .then((sections) => {
        const productHTML = this.getSectionInnerHTML(sections['theme-cart-notification-product'], `#cart-notification-product-${addedVariantId}`);
        if (productHTML === null) {
          // Edge case: the added line no longer exists (e.g. merged or removed in the meantime)
          debug() && console.warn(`Added variant ${addedVariantId} not found in cart notification section`);
          return;
        }

        document.getElementById('cart-notification-product').innerHTML = productHTML;
        document.getElementById('cart-notification-button').innerHTML = this.getSectionInnerHTML(sections['theme-cart-notification-button']);

        this.open();
      })
      .catch((error) => {
        debug() && console.error(error);
      });
  }

  renderQuantityError(inventoryQuantity, trigger) {
    this.trigger = trigger || null;
    const errorMessageElem = this.notification.querySelector('[data-cart-notification-error-message]');
    const inventoryQty = parseInt(inventoryQuantity) || 0;

    errorMessageElem.innerText = window.cartStrings.quantityError.replace('[quantity]', inventoryQty);

    this.open(true);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = document.createRange().createContextualFragment(html).querySelector(selector);
    return element ? element.innerHTML : null;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
